// import "rxjs-compat"; //TODO: remove compatibility layer
import React from "react";
import { render } from "react-dom";
import Root from "root/Root";
import configureStore, { history } from "configureStore";

const store = configureStore();
const rootElement = document.getElementById("root");

render(<Root store={store} history={history} />, rootElement);
